/**
 * Price-type discriminator for dbo.product_prices.price_type.
 *
 * Values mirror the backend's PriceType enum
 * (dev-inventory/src/databases/entities/enum/price-type.enum.ts).
 * Keep this file in sync when new types are added.
 *
 * The POS reads price_type via /api/v1/inventory/sync/product-prices/
 * to pick the right entry UI at sale time.
 */
export enum PriceType {
  Regular = 1,
  Weighted = 2,
  OpenPrice = 3,
  VariableQuantity = 4,
}

/**
 * Options array used to populate the Price Type dropdown on the Items
 * edit page. `name` strings are the locale-key form — pass through the
 * page's existing `language?.[name]` lookup for translation.
 */
export const PRICE_TYPE_OPTIONS: { value: number; name: string }[] = [
  { value: PriceType.Regular, name: 'Regular' },
  { value: PriceType.Weighted, name: 'Weighted' },
  { value: PriceType.OpenPrice, name: 'Open price' },
  { value: PriceType.VariableQuantity, name: 'Variable quantity' },
];
